var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('success-animation'),_c('div',{staticClass:"payment-suc"},[_c('p',{staticStyle:{"font-weight":"700"},attrs:{"dir":"rtl"}},[_vm._v("תודה רבה על תמיכתך!")]),_c('social-buttons',{attrs:{"title":_vm.shareMessage}}),_c('p',[_vm._v("שתפו את ההנצחה שלכם")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }